import React, { createContext, useContext, useEffect } from "react"
import { useViewerMaybe } from "~/auth/use-viewer"
import { initializeAnalytics, setAnalyticsUserId } from "./analytics"

interface AnalyticsContextType {
  isInitialized: boolean
}

const AnalyticsContext = createContext<AnalyticsContextType | null>(null)

export const AnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { viewer } = useViewerMaybe()

  useEffect(() => {
    initializeAnalytics().catch((error) => {
      console.error("Failed to initialize analytics:", error)
    })
  }, [])

  useEffect(() => {
    if (viewer?.id) {
      setAnalyticsUserId(viewer.id)
    }
  }, [viewer?.id])

  return (
    <AnalyticsContext.Provider value={{ isInitialized: true }}>
      {children}
    </AnalyticsContext.Provider>
  )
}

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext)
  if (!context) {
    throw new Error("useAnalytics must be used within an AnalyticsProvider")
  }
  return context
}
